import { gql, useMutation } from '@apollo/client';
import Modal from '../../lib/ui/Modal';
import { useState } from 'react';
import ButtonArea from '../../lib/forms/ButtonArea';
import ValidatedButton from '../../lib/forms/ValidatedButton';
import { Button, Form } from '@atrocit/scl';

export default function DeleteShipModal({ isOpen, onClose, shipId, refetch }) {
	const [ loading, setLoading ] = useState(false);

	const [ deleteShip ] = useMutation(gql`mutation Mutation($shipId: Int!) {
        deleteShip(shipId: $shipId)
    }`);

	function process() {
		setLoading(true);
		deleteShip({ variables: { shipId: shipId } }).finally(() => { refetch(); onClose(); });
	}

	return <Modal isOpen={isOpen} onClose={onClose} title="Schip verwijderen">
		{!loading && <Form style={{ maxWidth: "var(--u-384)" }} onSubmit={process}>
			<p style={{ marginTop: 0 }}>Wilt u dit schip verwijderen? Deze actie kan niet ongedaan gemaakt worden</p>
			<ButtonArea>
				<ValidatedButton type="submit" style={{ background: "var(--col-red)", color: "var(--col-white)", borderColor: 'var(--col-red-600)' }}>
					<span className="fa fa-trash" />&nbsp; Verwijderen
				</ValidatedButton>
				<Button onClick={onClose}>Annuleren</Button>
			</ButtonArea>
		</Form>}
		{loading && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
			<span className="fa fa-spinner fa-pulse" style={{ fontSize: 'var(--fs-18)' }} />
		</div>}
	</Modal>;
}